<div mat-dialog-title class="flex flex-row justify-between content-center items-center">
  <h2 class="text-xl font-semibold text-gray-800" [innerHTML]="title"></h2>
  <button [mat-dialog-close]="false" mat-icon-button>
    <mat-icon>close</mat-icon>
  </button>
</div>

<div mat-dialog-content class="panel-container flex flex-col items-stretch">
  <span
    class="mepco-home-text-subheaders flex flex-row justify-start items-center mb-2 sm:mb-5"
    [innerHTML]="description"></span>

  <!-- FIRST STEP -->
  @if (!data.gotToVerificationStep) {
    <mat-stepper
      [linear]="true"
      #stepper
      [orientation]="stepperOrientation()"
      [animationDuration]="'0ms'"
      (selectionChange)="onStepChange($event)">
      <mat-step [editable]="true" [stepControl]="selectedMethod" [completed]="selectedMethod.valid">
        <ng-template matStepLabel>Select a method</ng-template>

        <form (keydown.enter)="(false)" class="flex flex-col justify-center items-center m-y-3">
          <mat-button-toggle-group
            vertical="true"
            appearance="fill"
            [formControl]="selectedMethod"
            [hideSingleSelectionIndicator]="true">
            <mat-button-toggle [value]="appType"> <mat-icon>qr_code</mat-icon> APP </mat-button-toggle>
            @if (showPhoneOption()) {
              <mat-button-toggle [value]="smsType"> <mat-icon>smartphone</mat-icon> SMS </mat-button-toggle>
            }
            @if (showEmailOption()) {
              <mat-button-toggle [value]="emailType"> <mat-icon>email</mat-icon> EMAIL </mat-button-toggle>
            }
          </mat-button-toggle-group>

          <button type="button" [disabled]="selectedMethod.invalid" color="accent" mat-raised-button matStepperNext>
            Next
          </button>
        </form>
      </mat-step>

      <!-- SECOND STEP -->

      <mat-step [editable]="true">
        <ng-template matStepLabel> Generate code </ng-template>

        <ng-template matStepContent class="flex flex-col justify-center items-center">
          <app-mfa-setup [selectedMethod]="selectedMethod.getRawValue()"></app-mfa-setup>
          <div class="flex flex-row justify-between">
            <button type="button" mat-raised-button matStepperPrevious color="primary">Back</button>
            <button type="button" [disabled]="selectedMethod.invalid" mat-raised-button color="accent" matStepperNext>
              Next
            </button>
          </div>
        </ng-template>
      </mat-step>

      <!-- THIRD STEP -->
      <mat-step [editable]="false">
        <ng-template matStepLabel> Verify code </ng-template>
        <ng-template matStepContent class="flex flex-col justify-center items-center">
          <app-mfa-challenge
            [selectedMethod]="selectedMethod.getRawValue()"
            [mustVerify]="mustVerify()"
            (confirmSigned)="onSubmit($event)">
          </app-mfa-challenge>
        </ng-template>
      </mat-step>
    </mat-stepper>
  } @else {
    <app-mfa-challenge
      [selectedMethod]="selectedMethod.getRawValue()"
      [mustVerify]="false"
      (confirmSigned)="onSubmit($event)">
    </app-mfa-challenge>
  }
</div>
